import { useAsyncData } from '#imports'

import { toPublicPath } from '@backmarket/nuxt-layer-base/utils/toPublicPath'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useCompareToPrices() {
  const { market } = useMarketplace()

  const { data } = useAsyncData(
    `compare-to-prices-${market.countryCode}`,
    () =>
      $fetch<Record<string, number>>(
        toPublicPath(
          `/data/outlet/compare-to-prices-${market.countryCode}.json`,
        ),
      ),
    {
      default: () => ({}) as Record<string, number>,
      server: true,
      lazy: false,
    },
  )

  const getCompareToPrice = (objectID: string): number | null => {
    const productId = objectID.split('_')[0]

    return data.value[productId] ?? null
  }

  return { getCompareToPrice }
}
